import React, {useEffect, useState} from 'react';
import TermsConditions from "../components/Booking/Terms/TermsConditions";
import {Button, Container, Paper} from "@mui/material";
import BookingStepper from "../components/Booking/BookingStepper";
import Grid from "@mui/material/Grid";
import TripSummary from "../components/Booking/Summary/TripSummary";
import {useHistory, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
    bookingActions,
    getNextStep,
    getPreviousStep,
    getStepFromUrl,
    requestApi,
    restartBooking,
    showAlertAutoDis
} from "../utils/utils";
import {setStep} from "../redux/actions/stepActions";
import {getTripById} from "../redux/actions/tripActions";
import {useIsAuthenticated} from "react-auth-kit";
import GuestBar from "../components/GuestInfo/GuestBar";
import {TripPropTypes} from "../utils/PropTypes/TripPropTypes";


const TermsAndConditionsPage = () => {
    const {id} = useParams();
    const {data: trip} = useSelector(state => state.trip);
    const transactions = useSelector(state => state.transactions);
    const bookingType = useSelector(state => state.bookingType);
    const step = useSelector(state => state.step);
    const dispatch = useDispatch();
    const [terms, setTerms] = useState(false);
    const history = useHistory();
    const isAuth = useIsAuthenticated();
    const prevStep = getPreviousStep(step);
    const totals = useSelector((state) => state.totals);
    const selectedRooms = transactions?.selectedRooms || [];

    const validateTransactions = () => {
        if (sessionStorage.getItem('transactions')) {
            const transactionsFromSession = JSON.parse(sessionStorage.getItem('transactions'))
            if (parseInt(transactionsFromSession.tripId) !== parseInt(id))
                restartBooking(id);
        }

        if (transactions && transactions.selectedRooms.length < 1)
            restartBooking(id);
    };

    useEffect(() => {
        validateTransactions();
        const stepNum = getStepFromUrl(history.location.pathname);
        dispatch(setStep(stepNum));
    }, []);

    useEffect(() => {
        if (Object.keys(trip).length === 0)
            dispatch(getTripById(id))
    }, [trip?.TripId]);

    const acceptTerms = (event) => {
        const acceptTerms = event.target.checked;

        setTerms(acceptTerms);
    };

    const booking = async () => {
        if (terms) {
            const {
                data: {
                    status,
                    booking,
                    message,
                    restart
                }
            } = await requestApi('/booking/create', 'POST', {transactions, bookingType}, null, true);
            if (status === 'success') {
                return goToPayment(booking.id);
            } else {
                showAlertAutoDis({title: 'Error', text: message}, () => {
                    if (restart)
                        restartBooking(trip.TripId);
                });
            }
        }
    };

    const goBack = () => {
        history.push(`/booking/${id}${prevStep.url}`);
    };

    const goToPayment = (bookingId) => {
        const currentStep = getNextStep(step-1);
        bookingActions(
            currentStep.label,
            'Next Step',
            `${trip.TripId} - PAX: ${selectedRooms.length} - BookingType: ${bookingType}`,
            trip.locationInfo.location,
            trip.boarddate,
            parseFloat(totals.roomsAmount ?? 0).formatMoney(0))
        if (bookingType === 'pay')
            history.push(`/booking/payment/${bookingId}`);
        else
            history.push(`/booking/hold/${bookingId}`);
    };

    return (
        <div>
            {isAuth() && <GuestBar/>}
            <Container maxWidth="lg">
                <BookingStepper/>
                <div style={{marginTop: 50}}/>
                {trip && Object.keys(trip).length > 0 && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={9}>
                            <TermsConditions acceptTerms={acceptTerms} checkTerms={terms}/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3}>
                            <Paper>
                                <Button color={'primary'} variant={'contained'} fullWidth onClick={booking}
                                        disabled={!terms}>
                                    Next Step
                                </Button>
                                <Button color={'secondary'} variant={'contained'} fullWidth onClick={goBack}>
                                    Go Back to {prevStep.label}
                                </Button>
                            </Paper>
							<TripSummary/>
                        </Grid>
                    </Grid>
                )}
            </Container>
        </div>
    );
};

export default TermsAndConditionsPage;

TermsAndConditionsPage.propTypes = {
    trip: TripPropTypes,
}